import { Instagram } from "lucide-react";

const SOCIALS = [
  { name: "Instagram", icon: Instagram, url: "https://www.instagram.com/owen_bussines/", testid: "social-instagram-link" },
];

export const Footer = () => (
  <footer className="border-t border-white/10 py-12" data-testid="footer-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
        <div>
          <p className="font-display font-bold text-lg text-white" data-testid="footer-brand">OG Solutions</p>
          <p className="mt-2 text-sm text-slate-400" data-testid="footer-contact">
            <a href="mailto:owengraham5546@gmail.com" className="hover:text-white transition-colors duration-300">owengraham5546@gmail.com</a>
            <span className="mx-2 text-slate-600">|</span>
            <a href="tel:705-433-2050" className="hover:text-white transition-colors duration-300">705-433-2050</a>
          </p>
        </div>
        <div className="flex items-center gap-3">
          {SOCIALS.map((s) => (
            <a
              key={s.name}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.name}
              data-testid={s.testid}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-slate-400 transition-colors duration-300 hover:bg-white hover:text-[#060D1A] hover:border-white"
            >
              <s.icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
      <p className="mt-10 text-xs text-slate-600" data-testid="footer-copyright">
        © 2026 OG Solutions. All rights reserved.
      </p>
    </div>
  </footer>
);
